import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { StepType } from "@edp-models/contract-define-house-v2.model";
import { ShowLoader } from "@edp-store/actions/layout.actions";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiService } from "./api.service";

@Injectable({
    providedIn: "root",
})
export class ContractDefineHouseV2Service {
    private formStates: Array<{ step: number; data: any }> = [];
    private stepTypeSubject = new BehaviorSubject<StepType>(StepType.STEP);
    private equipamentSubstepSubject = new BehaviorSubject<string>("");
    private prefilledSubstepTypeSubject = new BehaviorSubject<string>("");

    constructor(private http: HttpClient, private apiService: ApiService, private store: Store<IAppState>) { }

    /* TODO: MAKE THIS METHOD MORE FUNCTIONAL WAY TO AVOID REPEATED CODE */
    public setFormData(step: number, data: any) {
        const existingForm = this.formStates.find(form => form.step === step);
        const substepKey = Object.keys(data)[0];

        if (!existingForm && this.stepTypeSubject.value === StepType.EQUIPAMENTS_SUBSTEP_TYPE) {
            const newForm = {
                step,
                data: { substep: [data] },
            };
            this.formStates.push(newForm);
            return;
        }

        if (existingForm && this.stepTypeSubject.value === StepType.EQUIPAMENTS_SUBSTEP_TYPE) {
            const equipamentSubstep = existingForm.data.substep.find((substep: any) => substep.equipament === data.equipament);
            if (equipamentSubstep) {
                equipamentSubstep.data = data.data;
            } else {
                existingForm.data.substep.push(data);
            }
            return;
        }

        if (existingForm) {
            if (this.stepTypeSubject.value === StepType.ENERGY_SOURCE_SUBSTEP_TYPE) {
                if (existingForm.data.substep) {
                    for (const key of Object.keys(data)) {
                        existingForm.data.substep[key] = data[key];
                    }
                } else {
                    existingForm.data.substep = data;
                }
            } else {
                if (existingForm.data.substep) {
                    existingForm.data[substepKey] = data[substepKey];
                } else {
                    existingForm.data = data;
                }
            }
        } else {
            const newForm = {
                step,
                data: data,
            };
            this.formStates.push(newForm);
        }
    }

    public getFormData(step: number) {
        const form = this.formStates.find(form => form.step === step);

        if (!form) {
            return null;
        }

        return form.data;
    }

    public clearFormData() {
        this.formStates = [];
    }

    public setStepType(stepType: StepType) {
        this.stepTypeSubject.next(stepType);
    }

    public getStepType() {
        return this.stepTypeSubject.value;
    }

    public getContractDefineData(account: string): Observable<any> {
        return this.apiService.callServicePostToCollectionCatalog("house.get", { account });
    }

    public postContractDefineData(args: any): Observable<any> {
        this.store.dispatch(new ShowLoader(true));
        /* LEAVE THIS FOR RIGHT NOW */
        /*    const data = args.map((arg: any) => {
            const [dynamicKey] = Object.keys(arg).filter(key => key !== "category" && key !== "page");

            return {
                category: arg.category,
                page: arg.page,
                queryCode: dynamicKey,
                data: arg[dynamicKey],
            };
        });

        console.log("data", data); */

        return this.apiService.callServicePostToCollectionCatalog("house.update", args);
    }

    public postContractDefineDataWtLoader(args: any): Observable<any> {
        return this.apiService.callServicePostToCollectionCatalog("house.update", args);
    }

    public getContractDefineStatusMoonshot(account: string): Observable<any> {
        return this.apiService.callServicePostToCollectionCatalog("house.status", { account });
    }

    public getContractEenergyTariffTips(CPE: string): Observable<any> {
        return this.apiService.callServicePostToCollectionCatalog("house.energy.tariffTips", { CPE })
            .pipe(map((response: any) => response[0]));
    }

    public setEquipementSubstep(step: string) {
        this.equipamentSubstepSubject.next(step);
    }

    public getEquipamentSubstep() {
        return this.equipamentSubstepSubject.value;
    }

    public setPreFilledSubstepType(substepType: string) {
        this.prefilledSubstepTypeSubject.next(substepType);
    }

    public getPreFilledSubstepType() {
        return this.prefilledSubstepTypeSubject.value;
    }
}
